import React from 'react';

const Contact = () => {
  return (
    <section id="how-it-works" className="contact-section">
      <h2>Interested in Purchasing?</h2>
      <div className="contact-info">
        <p>Serious inquiries only, please contact:</p>
        <a href="mailto:sarahchen235@gmail.com" className="email-link">
          sarahchen235@gmail.com
        </a>
        <p className="note">* Only legitimate offers will receive a response</p>
      </div>
    </section>
  );
};

export default Contact; 